var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('v-tooltip',{attrs:{"top":"","lazy":"","max-width":"300"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({},on),[_c('div',{staticClass:"child"},[_vm._t("default")],2)])]}}],null,true)},[_c('span',[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }